import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireAuth } from '@/lib/middleware'
import { FollowupDetailPage } from '@/features/medication-followups/followup-detail-page'

/** One follow-up case on its own page (Phase 2 Task 6a). */
export const Route = createFileRoute(
  '/_authenticated/_organization/medication-followups/$occurrenceId/'
)({
  beforeLoad: async () => {
    await requireAuth()
    await requireActiveSubscription()
  },
  component: FollowupDetailPage,
})
